<template>
    <div class="disclaimer">
        <div class="col-md-12">
            <p class="p-disclaimer">
                All prices are indicative and represent the commodity element only. These reports have been prepared by Trio for illustrative purposes only.
                Data contained herein include information analyzed and calculated by Trio with raw data licensed from Montel AS, EEX Group, EPEX SPOT SE, and ICE Data Services.
                Source: Montel AS; Source: EEX Group; Source: EPEX SPOT SE; Source: ICE Data Services. &copy; EEX Group, EPEX SPOT SE, and Intercontinental Exchange, Inc. All rights reserved. 
                The data are provided &quot;as is&quot; without any guarantee of accuracy, completeness, or timeliness.
                Trio, Montel AS, EEX Group, EPEX SPOT SE, and ICE Data Services accept no liability for any loss, damage, or inconvenience arising from reliance on this information.
                The client must exercise due diligence and rely upon their own judgement when making commercial decisions.
                Montel AS, EEX Group, EPEX SPOT SE, and ICE&reg; are registered trademarks of their respective owners. Their names and data are used solely for reference and attribution purposes. Trio is not affiliated with, endorsed by, or otherwise associated with Montel AS, EEX Group, EPEX SPOT SE, or Intercontinental Exchange, Inc.
                These reports are considered commercial-in-confidence and, under no circumstances, may these documents or any part of their contents be published or distributed.
            </p>
        </div>
    </div>
</template>

<script>
    import Vue from 'vue';
    import apis from '@/common/network';

    export default Vue.extend({
        created() {

        },
        data() {
            return {

            }
        },
        methods: {

        }
    })
</script>

<style>
    .disclaimer {
        display: flex;
        background-color: white;
        width: 100%;
        text-align: justify;
    }

    .p-disclaimer {
        margin: 0px 0px 0px 0px;
        padding-top: 5px;
        padding-bottom: 5px;
    }
</style>